// Fetch courtesies
export const FETCH_COURTESIES_REQUEST = 'FETCH_COURTESIES_REQUEST';
export const FETCH_COURTESIES_SUCCESS = 'FETCH_COURTESIES_SUCCESS';
export const FETCH_COURTESIES_FAILURE = 'FETCH_COURTESIES_FAILURE';

export const fetchCourtesiesRequest = () => ({ type: FETCH_COURTESIES_REQUEST });
export const fetchCourtesiesSuccess = (courtesies) => ({ type: FETCH_COURTESIES_SUCCESS, payload: courtesies });
export const fetchCourtesiesFailure = (error) => ({ type: FETCH_COURTESIES_FAILURE, payload: error });

// Grant courtesy
export const GRANT_COURTESY_REQUEST = 'GRANT_COURTESY_REQUEST';
export const GRANT_COURTESY_SUCCESS = 'GRANT_COURTESY_SUCCESS';
export const GRANT_COURTESY_FAILURE = 'GRANT_COURTESY_FAILURE';

export const grantCourtesyRequest = (data) => ({ type: GRANT_COURTESY_REQUEST, payload: data });
export const grantCourtesySuccess = (courtesies) => ({ type: GRANT_COURTESY_SUCCESS, payload: courtesies });
export const grantCourtesyFailure = (error) => ({ type: GRANT_COURTESY_FAILURE, payload: error });

// Revoke courtesy
export const REVOKE_COURTESY_REQUEST = 'REVOKE_COURTESY_REQUEST';
export const REVOKE_COURTESY_SUCCESS = 'REVOKE_COURTESY_SUCCESS';
export const REVOKE_COURTESY_FAILURE = 'REVOKE_COURTESY_FAILURE';

export const revokeCourtesyRequest = (courtesyId) => ({ type: REVOKE_COURTESY_REQUEST, payload: courtesyId });
export const revokeCourtesySuccess = (courtesyId) => ({ type: REVOKE_COURTESY_SUCCESS, payload: courtesyId });
export const revokeCourtesyFailure = (error) => ({ type: REVOKE_COURTESY_FAILURE, payload: error });
